import { addContentBesideSection } from "./addContentBesideSection.js";
import { conditionalControls } from "./conditionalControls.js";
import { customControl } from "./customControl.js";
import { getSidebarCustomize } from "./getSidebarCustomize.js";
import { initializeTinyMce } from "./initializeTinyMce.js";
import { makeDefaultsResettable } from "./makeDefaultsResettable.js";
import { ready } from "./ready.js";
import { CssMarginInput } from "../components/cssMarginInput.js";
import { CustomHTML } from "../components/customHtml.js";
import { Headline } from "../components/headline.js";
import { RangeInput } from "../components/rangeInput.js";
/**
 * A factory functionality which provides different implementations especially
 * for the "sidebar" use case. Also, it predefine some controls.
 */ function sidebarFactory(param) {
    let { panel, ids, defaults, onReady, conditionals, controls, contentBesideSection } = param;
    ready((customize)=>{
        // Only run the factory if panel exists
        if (!getSidebarCustomize().panel(panel)) {
            return;
        }
        conditionals && conditionalControls(panel, conditionals);
        contentBesideSection && addContentBesideSection(contentBesideSection);
        makeDefaultsResettable(ids, defaults);
        initializeTinyMce();
        onReady(customize);
    });
    controls && customControl(controls);
    // Predefine components
    customControl({
        cssMargin: CssMarginInput,
        rangeInput: RangeInput,
        headline: Headline,
        customHtml: CustomHTML
    });
    return true;
}
export { sidebarFactory };
